import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * プロパティ定義
 */
type Props = {
  /** 子要素 */
  children?: React.ReactNode;
  /** 背景色有か */
  bgColor?: boolean;
  /** リセット位置初期化の要否(デフォルトはtrue) */
  resetScroll?: boolean;
};

/**
 * アプリ共通のページ全体コンポーネント
 * @param param コンポーネントのProps
 */
export default function AppScreen({ children, bgColor = false, resetScroll = true }: Props) {
  const { pathname } = useLocation();

  useEffect(() => {
    // MAAS_EMETRO_OPE-653対応(※調査の結果、不具合だった)
    // - 下部の「スクロール位置をリセットする」の処理により、スクロール位置を変更する処理が動作しなくなっていた
    if (!resetScroll) return;

    // 画面遷移する度にスクロール位置をリセットする
    // -- 特定のiPhoneでスクロールした状態で画面遷移したあと、
    // -- ヘッダーの戻るボタンを押下すると、ヘッダーが消えたり画面が白くなることがあった
    // -- 原因は不明だが、画面表示後動かすと消えるので500ミリ秒後に1pxずらすことで対応する
    setTimeout(() => window.scrollTo(0, 1), 500);
  }, [pathname]);

  const getClass = () => {
    let c = "App";
    if (bgColor) c += " App-Bgcolor";
    return c;
  };

  return <div className={getClass()}>{children}</div>;
}
